import { render, staticRenderFns } from "./AppointmentTypeFilterList.vue?vue&type=template&id=6871634e&scoped=true&"
import script from "./AppointmentTypeFilterList.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppointmentTypeFilterList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppointmentTypeFilterList.vue?vue&type=style&index=0&id=6871634e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6871634e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6871634e')) {
      api.createRecord('6871634e', component.options)
    } else {
      api.reload('6871634e', component.options)
    }
    module.hot.accept("./AppointmentTypeFilterList.vue?vue&type=template&id=6871634e&scoped=true&", function () {
      api.rerender('6871634e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/AppointmentTypeFilterList/AppointmentTypeFilterList.vue"
export default component.exports